function initiateAOSAnimation() {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://unpkg.com/aos@next/dist/aos.css";

  const script = document.createElement("script");
  script.src = "https://unpkg.com/aos@next/dist/aos.js";
  script.defer = true;

  script.onload = function () {
    AOS.init();
  };

  document.head.appendChild(link);
  document.head.appendChild(script);
}

// ============== MAIN ============== //
setTimeout(() => {
  initiateAOSAnimation();
}, 20);
